import gql from "graphql-tag";

export default gql`
  mutation AdminCancelSubscription($id: Int!) {
    admin_cancelSubscription(id: $id) {
      id
    }
  }
`;
